<template>
  <nav-bar :menuItems="menuItems" :portalButton="true" />
</template>
<script>
export default {
	name: "NavigationBarSustainability",
	data: () => ({
		menuItems: [
			{ title: "Survey", link: "/csr" },
			{ title: "Dashboard", link: "/csr/dashboard" },
			{ title: "ESG Score", link: "/csr/esgscore" },
			{ title: "Risk Matrix", link: "/csr/riskmatrix" },
			{ title: "Knowledge Page", link: "/csr/knowledgepage" },
		],
		sidebar: false
	})
}
</script>
